// extracted by mini-css-extract-plugin
export default {"notFound":"notFound_notFound__TOQ2U","errorCode":"notFound_errorCode__hIQ6+"};